import { inject } from '@angular/core';
import { CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { ConnectionService } from '../../services/connection.service';
import { UserService } from '../../services/user.service';

export const userGuard: CanActivateFn = async (_: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
	const userService = inject(UserService);
	if (!userService.loggedUser) {
		const connectionService = inject(ConnectionService);
		connectionService.updateAccessToken();
		const logged = await userService.updateLoggedUser();
		if (!logged) {
			connectionService.requestLogin(state.url)
				.catch((error: unknown) => {
					console.error('error displaying login page', error);
				});
			return false;
		}
		try {
			await userService.updateUserData();
		} catch (err) {
			console.error('error updating user data', err);
		}
	}
	return true;
};
